import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserWidgetComponent from '../widgets/user';
import { FETCH_LEADERS, FETCH_USER_NUMBER } from '../../constants/action-types';

class Leaderboard extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {

        this.props.getLeaders();
        this.props.getUserNumber();

    }

    componentWillUpdate() {


    }

    render() { 
        return (
            <section id='leaders' className='content-section-wrap'>
                <div id='leaders-head' className='content-section-head'>
                    <h1 className='mvu-head xl'>Leaders</h1>
                </div>

                <div id='leaders-list-wrap' className='content-section'>
                    {(this.props.leaders.length === 0 && !this.props.leadersLoading) ? (
                        <div className='content-section-empty'>
                            <h1>No leaders found</h1>
                        </div>
                    ) : null}
                    {this.props.leadersLoading ? (
                        <div className='content-section-empty'>
                            <h1>Loading</h1>
                        </div>)
                    : null}
                    {this.props.leaders.length !== 0 ? (
                        <div>
                            <div id='leaders-list-heading'>
                                <div id='leaders-list-heading-left'></div>
                                <div id='leaders-list-heading-right'>
                                    <small># Bets Won</small>
                                    <small># Bounty Points</small>
                                </div>
                            </div>
                            <ul id='leaders-list'>
                                {this.props.leaders.map((leader, index) => (
                                    <li key={index.toString()} className='leader-list-item'> 
                                        <h6>#{index + 1}</h6>
                                        <UserWidgetComponent user={leader}/>
                                        <div className='leader-list-item-right'>
                                            <small>{leader.bets_won}</small>
                                            <small>{leader.bounty_points}</small>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null }
                </div>
                <small>Showing top 10 out of {this.props.userNumber}</small>
            </section>
        );
    }
}

const mapStateToProps = (state) => state.leaders

const mapDispatchToProps = (dispatch) => ({
    getLeaders: () => dispatch({ type: FETCH_LEADERS }),
    getUserNumber: () => dispatch({ type: FETCH_USER_NUMBER })
});

export default connect( 
    mapStateToProps, 
    mapDispatchToProps
)(Leaderboard)



// WEBPACK FOOTER //
// ./src/components/general/Leaderboard.js